import { FC } from "react";
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import {
  METRICS_DATE_RANGE_OPTIONS,
  MetricsDateRange,
} from "../metricsDateRange";

type Props = {
  value: MetricsDateRange;
  onChange: (value: MetricsDateRange) => void;
  fullWidth?: boolean;
};

export const MetricsDateRangeFilter: FC<Props> = ({
  value,
  onChange,
  fullWidth = false,
}) => {
  const handleChange = (event: SelectChangeEvent<MetricsDateRange>) => {
    onChange(event.target.value as MetricsDateRange);
  };

  return (
    <FormControl
      size="small"
      fullWidth={fullWidth}
      sx={fullWidth ? { width: "100%" } : { minWidth: 200 }}
    >
      <InputLabel id="metrics-date-range-label" shrink>
        Feedback period
      </InputLabel>
      <Select
        labelId="metrics-date-range-label"
        id="metrics-date-range"
        value={value}
        label="Feedback period"
        onChange={handleChange}
        fullWidth={fullWidth}
        notched
      >
        {METRICS_DATE_RANGE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
